export default __webpack_public_path__ + "static/media/mximg7.a9d48114.webp";